<div id="head"></div>

<div class="themes-dashboard">

  <!-- ============ Sticky sidebar: filters & summary ============ -->
  <aside class="dashboard-sidebar">
    <div class="sidebar-inner">

      <div class="sidebar-header">
        <span class="sidebar-kicker">Browse</span>
        <h1 class="sidebar-title">Theme Gallery</h1>
        <p class="sidebar-subtitle">
          Explore moods, colors, and styles crafted to transform your user interface.
        </p>
      </div>

      <!-- Result summary + clear all -->
      <div class="sidebar-summary">
        <div class="result-count">
          <span class="result-number">{{ filteredProducts.length }}</span>
          <span class="result-label">{{ filteredProducts.length === 1 ? 'theme' : 'themes' }}</span>
        </div>
        <button type="button" class="clear-all"
                *ngIf="totalActiveFilters > 0"
                (click)="clearAllFilters()">
          Clear all
          <span class="clear-all-count">{{ totalActiveFilters }}</span>
        </button>
      </div>

      <!-- Filters -->
      <div class="filter-blocks">

        <!-- Sort -->
        <div class="filter-block">
          <div class="filter-block-head">
            <span class="filter-block-title">Sort by</span>
          </div>
          <div class="filter-dropdown" [class.open]="activeDropdown === 'sort'">
            <button type="button" class="dropdown-trigger"
                    (click)="toggleDropdown('sort', $event)">
              <span class="dropdown-trigger-label">{{ selectedSortLabel }}</span>
              <span class="dropdown-caret" aria-hidden="true"></span>
            </button>
            <ul class="dropdown-options"
                *ngIf="activeDropdown === 'sort'"
                (click)="$event.stopPropagation()">
              <li *ngFor="let opt of sortOptions"
                  class="dropdown-option"
                  [class.active]="selectedSort === opt.value"
                  (click)="setSort(opt.value)">
                {{ opt.label }}
              </li>
            </ul>
          </div>
        </div>

        <!-- Category: the options in one dock (owner 2026-10-15: the home boxes' docks);
             none lit is all of them, the lit one clicked again clears it -->
        <div class="filter-block" *ngIf="filterOptions.category.length > 0">
          <div class="filter-block-head">
            <span class="filter-block-title">Category</span>
          </div>
          <div class="filter-dock" role="group" aria-label="Category">
            <button type="button" class="dock-chip" *ngFor="let v of filterOptions.category"
                    [class.on]="selectedFilters.category.includes(v)" [attr.aria-pressed]="selectedFilters.category.includes(v)"
                    (click)="toggleFilter('category', v)">{{ v }}</button>
          </div>
        </div>

        <!-- Appearance: the options in one dock (owner 2026-10-15: the home boxes' docks);
             none lit is all of them, the lit one clicked again clears it -->
        <div class="filter-block">
          <div class="filter-block-head">
            <span class="filter-block-title">Appearance</span>
          </div>
          <div class="filter-dock" role="group" aria-label="Appearance">
            <button type="button" class="dock-chip" *ngFor="let v of filterOptions.appearance"
                    [class.on]="selectedFilters.appearance.includes(v)" [attr.aria-pressed]="selectedFilters.appearance.includes(v)"
                    (click)="toggleFilter('appearance', v)"><span class="appearance-dot" [attr.data-appearance]="v"></span>{{ v }}</button>
          </div>
        </div>

        <!-- Color: the colors as swatches in a dock, like the platforms (owner 2026-10-15); the one picked
             named beside the title -->
        <div class="filter-block" *ngIf="filterOptions.color.length > 0">
          <div class="filter-block-head">
            <span class="filter-block-title">Color</span>
            <span class="filter-block-value" *ngIf="selectedFilters.color.length > 0">{{ selectedFilters.color[0] }}</span>
          </div>
          <div class="filter-dock filter-dock-logos" role="group" aria-label="Color">
            <button type="button" class="dock-logo" *ngFor="let color of filterOptions.color"
                    [class.on]="selectedFilters.color.includes(color)" [attr.aria-pressed]="selectedFilters.color.includes(color)"
                    [title]="color" [attr.aria-label]="color"
                    (click)="toggleFilter('color', color)">
              <span class="color-swatch" [style.background]="getMainColorSwatch(color)"></span>
            </button>
          </div>
        </div>

        <!-- Tags -->
        <div class="filter-block" *ngIf="filterOptions.tag.length > 0">
          <div class="filter-block-head">
            <span class="filter-block-title">Tag</span>
            <span class="filter-block-badge" *ngIf="selectedFilters.tag.length > 0">
              {{ selectedFilters.tag.length }}
            </span>
          </div>
          <div class="filter-dropdown" [class.open]="activeDropdown === 'tag'">
            <button type="button" class="dropdown-trigger"
                    (click)="toggleDropdown('tag', $event)">
              <span class="dropdown-trigger-label">
                {{ selectedFilters.tag.length > 0 ? selectedFilters.tag[0] : 'All tags' }}
              </span>
              <span class="dropdown-caret" aria-hidden="true"></span>
            </button>
            <ul class="dropdown-options"
                *ngIf="activeDropdown === 'tag'"
                (click)="$event.stopPropagation()">
              <li *ngFor="let tag of filterOptions.tag"
                  class="dropdown-option"
                  [class.active]="selectedFilters.tag.includes(tag)"
                  (click)="selectFromDropdown('tag', tag)">
                {{ tag }}
              </li>
            </ul>
          </div>
          <div class="selected-chips" *ngIf="selectedFilters.tag.length > 0">
            <span class="chip" *ngFor="let tag of selectedFilters.tag">
              {{ tag }}
              <button type="button" class="chip-remove"
                      (click)="toggleFilter('tag', tag)"
                      aria-label="Remove filter">&times;</button>
            </span>
          </div>
        </div>

        <!-- Featured -->
        <div class="filter-block">
          <div class="filter-block-head">
            <span class="filter-block-title">Featured</span>
            <span class="filter-block-badge" *ngIf="selectedFilters.featured.length > 0">
              {{ selectedFilters.featured.length }}
            </span>
          </div>
          <div class="filter-dropdown" [class.open]="activeDropdown === 'featured'">
            <button type="button" class="dropdown-trigger"
                    (click)="toggleDropdown('featured', $event)">
              <span class="dropdown-trigger-label">
                {{ selectedFilters.featured.length > 0 ? selectedFilters.featured[0] : 'All featured' }}
              </span>
              <span class="dropdown-caret" aria-hidden="true"></span>
            </button>
            <ul class="dropdown-options"
                *ngIf="activeDropdown === 'featured'"
                (click)="$event.stopPropagation()">
              <li *ngFor="let label of filterOptions.featured"
                  class="dropdown-option"
                  [class.active]="selectedFilters.featured.includes(label)"
                  (click)="selectFromDropdown('featured', label)">
                {{ label }}
              </li>
            </ul>
          </div>
          <div class="selected-chips" *ngIf="selectedFilters.featured.length > 0">
            <span class="chip" *ngFor="let label of selectedFilters.featured">
              {{ label }}
              <button type="button" class="chip-remove"
                      (click)="toggleFilter('featured', label)"
                      aria-label="Remove filter">&times;</button>
            </span>
          </div>
        </div>

        <!-- Platform: the platforms in a dock, like the home boxes' platform dock, each with its name (owner
             2026-10-15: not everyone knows the logos); MacOS Terminal reads "MacOS" here so it fits -->
        <div class="filter-block">
          <div class="filter-block-head">
            <span class="filter-block-title">Platform</span>
          </div>
          <div class="filter-dock filter-dock-named" role="group" aria-label="Platform">
            <button type="button" class="dock-named" *ngFor="let plat of filterOptions.platform"
                    [class.on]="selectedFilters.platform.includes(plat.name)" [attr.aria-pressed]="selectedFilters.platform.includes(plat.name)"
                    [title]="plat.name"
                    (click)="toggleFilter('platform', plat.name)">
              <img [src]="plat.logo" alt="" width="18" height="18"><span>{{ plat.name === 'MacOS Terminal' ? 'MacOS' : plat.name }}</span>
            </button>
          </div>
        </div>

        <!-- Pricing: the options in one dock (owner 2026-10-15: the home boxes' docks);
             none lit is all of them, the lit one clicked again clears it -->
        <div class="filter-block">
          <div class="filter-block-head">
            <span class="filter-block-title">Pricing</span>
          </div>
          <div class="filter-dock" role="group" aria-label="Pricing">
            <button type="button" class="dock-chip" *ngFor="let v of filterOptions.pricing"
                    [class.on]="selectedFilters.pricing.includes(v)" [attr.aria-pressed]="selectedFilters.pricing.includes(v)"
                    (click)="toggleFilter('pricing', v)">{{ v }}</button>
          </div>
        </div>

      </div>
    </div>
  </aside>

  <!-- ============ Main area: themes grid ============ -->
  <main class="dashboard-main">
    <div class="themes-plate">
      <div class="themes-grid" #themesGrid>
        <ng-container *ngFor="let product of displayedProducts; let i = index; trackBy: trackByKey">
          <app-theme-card [attr.data-key]="product.key"
                          [class.flip-entering]="enteringKeys.has(product.key)"
                          [class.expanded]="expandedProduct?.key === product.key"
                          [product]="product"
                          [category]="product.category"
                          [selectable]="!isMobileCached"
                          (cardSelect)="toggleExpander(product, i)"
                          [ribbon]="isThemeFree(product) ? {text: 'Free', theme: ''} : {text: 'Premium', theme: ''}"
                          [selectedPlatform]="selectedFilters.platform[0]"
                          [selectedPricing]="selectedFilters.pricing[0]"
                          [screenshotMode]="false">
          </app-theme-card>
          <!-- Full-width detail row: opens between the clicked card's row and
               the next one (the grid pushes the following rows down). -->
          <div class="expander-row"
               *ngIf="expandedProduct && i === expanderAfterIndex"
               [class.open]="expanderOpen"
               [style.--arrow-x.px]="expanderArrowX">
            <div class="expander-clip">
              <app-theme-expander [product]="expandedProduct"
                                  [category]="expandedProduct.category"
                                  [selectedPlatformFilter]="selectedFilters.platform[0]"
                                  [selectedPricingFilter]="selectedFilters.pricing[0]">
              </app-theme-expander>
            </div>
          </div>
        </ng-container>
      </div>

      <div *ngIf="displayedProducts.length === 0" class="no-results">
        <div class="no-results-title">No themes match your filters</div>
        <p class="no-results-sub">Try removing a filter or two to see more results.</p>
        <button type="button" class="clear-all" (click)="clearAllFilters()">
          Clear all filters
        </button>
      </div>
    </div>
  </main>

</div>

<!-- Platform Coverage at the foot of the page, under the gallery and its sidebar (owner 2026-10-11,
     moved from the home) -->
<app-coverage-matrix class="themes-coverage"></app-coverage-matrix>
